<template>
    <div :class="['app-loader-fill', 'progress']" :style="inlineStyles">
        <div :class="`progress-bar bg-${color} progress-bar-striped progress-bar-animated w-100`"></div>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    props: {
        color: {
            type: String,
            default: 'slate-400'
        },
        width: {
            type: Number,
            default: null
        }
    },
    computed: {
        generatedWidth () {
            return this.width || _.random(100, 200)
        },
        inlineStyles () {
            const width = `width: ${this.generatedWidth}px;`
            return width
        }
    }
}
</script>
